export function calculateScore(score: { achieved: number; maximum: number }): number {
  return Math.round((score.achieved / score.maximum) * 100);
}
